/*
* @Description: In User Settings Edit
* @Author: your name
* @Date: 2019-08-09 16:41:54
* @LastEditTime: 2019-12-19 10:53:49
* @LastEditTime: 2019-09-09 11:43:43
* @LastEditors: Please set LastEditors
*/

export default {
  general: {
    save: 'hifadhi',
    autosaved: 'Iliyohifadhiwa',
    back_to: 'Rudi kwa',
    by: 'Na',
    chat: 'maongezi',
    completed: ' Imekamilika',
    canceled: 'Imeghairiwa',
    component: 'Kijenzi',
    confirm: ' thibitisha',
    course: ' kozi',
    date: 'Tarehe',
    details: ' Maelezo',
    empty: ' Hakuna data',
    enrolled: 'Umejiandikisha',
    free: ' Bure',
    graph: 'Grafu',
    loading: 'Inapakia...',
    lesson: 'somo',
    lessons: 'masomo',
    live_assessment: 'Tathmini ya moja kwa moja',
    live_event: 'Tukio la moja kwa moja',
    no: ' Hapana',
    of: 'Ya',
    or: 'Au',
    organization: 'Shirika',
    page: ' Ukurasa',
    pages: 'Kurasa',
    personal: ' Binafsi',
    poll: 'Kura',
    rating: ' Ukadiriaji',
    reset: 'Weka upya',
    signin: 'Ingia',
    signup: 'Jisajili',
    soon: 'Hivi karibuni',
    type: 'Piga chapa',
    uploading: ' Inapakia...',
    yes: 'Ndio',
    something_went_wrong: 'Kuna kitu kimeenda vibaya!',
    view_all: 'Tazama zote',
    upload_successful: 'kupakia kumefanikiwa',
    upload_successful_message:
' Nyaraka zako bora zimepakiwa vizuri na sasa inashughulikiwa. Hii inaweza kuchukua muda.',
    check_email_upload_successful:
'Tafadhali <0> angalia barua pepe yako </0> kwa ripoti ya <1> </1> ya orodha ya watumiaji waliyopakiwa',
    is_private: 'Binafsi'
  },

  account: {
    title: 'Akaunti',
    subtitle: 'Simamia mipangilio yako na habari ya akaunti.',
    saved: 'Akaunti ilibadilishwa vizuri'
  },

  assessments: {
    title: 'Tathmini',
    subtitle: 'Unda tathmini',
    finished: 'Tathmini imekamilika',
    countdown: 'Tathmini ya moja kwa moja itakuwa ikitangaza kwa',
    create: 'Unda Tathmini',
    list_title: 'Tathmini zako',
    delete_warning: 'Una uhakika unataka kufuta jambo hili?',
    details_title: 'Ongeza Maelezo ya Tathmini',
    details_subtitle:
    'Taja tathmini yako na uwaambie watazamaji wako kile wanachotarajia kujifunza kutoka kwake.',
    disclaimer: `Niagiza kwamba tathmini yangu iliyorekodiwa haitafanya:
     - kukiuka haki za mtu yeyote wa tatu
     - Inayo uharamia wowote, pamoja na uchafu
     - Inashambulia mtu yeyote kwa watu wengine
     - Inayo uigaji wowote wa washiriki wengine, takwimu za umma au watu mashuhuri
     - Inayo habari yoyote ya kurekodi au ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na haiko katika ukiukaji wa sheria yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
     - Inayo rufaa ya kibiashara au aina yoyote ya "barua taka”'`,

    // added_first
    assessment_details: 'maelezo ya tathmini',
    assessment_settings: 'mipangilio ya tathmini'
  },

  buildersettings: {
    title: 'mipangilio ya kuchapisha',
    subtitle:
  'Ongeza mipangilio kwenye hafla yako, ambaye anaweza kutazama na kuingiliana na tukio lako'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Ongeza',
    add_page: 'Ongeza ukurasa',
    add_lesson: 'Ongeza masomo',
    add_answer: 'Ongeza jibu mpya',
    add_group: 'Ongeza Kikundi',
    add_organization: 'Ongeza Shirika',
    add_question: 'Ongeza swali',
    add_quiz: 'Ongeza Jaribio',
    add_users: 'Ongeza Watumiaji',
    back: ' Nyuma',
    back_to_course: 'Rudi kwa muhtasari wa kozi',
    back_to_lesson: 'Rudi kwenye muhtasari wa somo',
    back_to_media: 'Rudi kwenye Maktaba ya Media',
    back_to_details: 'Rudi kwenye maelezo',
    cancel: 'Ghairi',
    clear: 'Futa',
    close: 'Funga',
    clone: 'Clone',
    close_lesson: 'Funga Somo',
    clone_course: ' Kozi ya Clone',
    confirm: 'Thibitisha',
    create: 'Unda',
    download: 'Pakua',
    download_mass_user_template: ' Pakua Kiolezo',
    add_mass_users: 'Ongeza Watumiaji wengi',
    upload_excel_list: 'Pakia Orodha ya Excel',
    delete: 'Futa Media',
    edit: 'Hariri',
    edit_course: 'Harir kozi',
    enroll: 'Jiandikishe',
    finish: 'Maliza',
    upload_image: 'Pakia picha',
    upload_image_video: 'Pakia picha au video',
    select_media_library: 'Chagua maktaba ya media',
    make_public: 'Fanya Umma',
    make_private: 'Fanya faragha',
    make_org: 'Fanya ya Shirika',
    media: 'Maktaba ya Media',
    my_theme: 'Mada yangu',
    next: 'Ifuatayo',
    next_lesson: 'Somo lifutalo',
    next_step: 'Hatua ifuatayo',
    previous_step: 'Hatua iliyotangulia',
    publish: 'Chapisha',
    publish_assessment: 'Chapisha tathmini yako',
    publish_course: 'Chapisha kozi yako',
    publish_event: 'Chapisha tukio lako',
    reset: 'Weka upya',
    reset_elements: 'Rudisha vipengee',
    save: 'Hifadhi',
    creating: 'Inaunda...',
    updating: 'Inasasisha...',
    saved: 'Imehifadhiwa',
    save_for_later: 'Hifadhi kwa baadaye',
    save_settings: 'Hifadhi mipangilio',
    select_files: 'Chagua faili',
    select_theme: 'Chagua mandhari',
    start_lesson: 'Anza Somo',
    update: 'Sasisha',
    upload: 'Pakia',
    upload_audio: 'Pakia Sauti',
    upload_photo: 'Pakia picha ya wasifu',
    upload_video: 'Pakia Video',
    enrolled: 'Umeandikishwa',
    unenroll: 'Sijiandikishe',
    from_library: 'Maktaba ya Media',
    remove: 'Ondoa',
    removed: 'Imeondolewa',
    start_broadcast: 'Anza Matangazo',
    end_broadcast: 'Maliza Matangazo',
    camera: 'Kamera',
    screen: 'Skrini',
    screen_with_camera: 'Skrini na Kamera',

    // added_first
    insert: 'Ingiza',
    inserting: 'Inaingiza'
  },

  card: {
    quick_add: 'Ongeza haraka',
    add: 'Ongeza',
    clone: 'Clone',
    completed: 'masomo yamekamilika'
  },

  course: {
    upcoming_course: 'Kozi inayokuja',
    unPublishEvent: 'Sichapishe Tukio',
    unPublishAssessment: 'Sichapishe Tathmini',
    pastCourse: 'Kozi ya Mafunzo',
    upcoming: 'Tukio lijalo la Moja kwa Moja',
    pastEvent: 'Tukio la Moja kwa Moja la zamani',
    pastAssessment: 'Tathmini ya Moja kwa Moja ya zamani',
    upcomingAssessment: 'Tathmini inayokuja ya Moja kwa Moja',
    created: 'Tarehe Iliyoundwa:',
    assignees: 'Waliopangiwa',
    organisations:
  ' {{mashirika}} mashirika   <2> {{watumiaji]} watumiaji </2>',
    event_date: 'Tarehe ya tukio moja kwa moja <1> {{tarehe}} </1>',
    delete_warning: 'Una uhakika unataka kufuta hii',
    clonning_no_lesson:
  'Tafadhali ongeza Somo moja angalau ili uclone kozi hii.',
    clone_warning: 'Una uhakika unataka kuclone hii',
    clone_success: 'iko kwenye mchakato wa clone',
    disclaimer: `Ninahakikisha kwamba kozi yangu haifanyi:
     - kukiuka haki za mtu yeyote wa tatu
     - Inayo uharamia wowote   pamoja na uchafu
     - Inashambulia mtu yeyote kwa watu wengine
     - Inayo uigaji wowote wa washiriki wengine   takwimu za umma au watu mashuhuri
     - ina habari yoyote ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na sio kwa kukiuka kanuni yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
     - Inayo rufaa yoyote ya kibiashara au aina yoyote ya "barua taka”`
  },

  coursecreate: {
    dropzone_text: 'Ingiza media',
    sidebar_text: 'Chagua mada <1 /> kwa <3 /> masomo yako',
    delete_warning: 'Je! Una uhakika unataka kufuta somo hili?'
  },

  coursepage: {
    quizview_loading: 'Inaangalia majibu. Tafadhali subiri...',
    quizview_answer: ' Jibu lako'
  },

  coursequiz: {
    title: 'Jaribio katika Masomo yote'
  },

  dashboard: {
    tooltip_title: 'Usionyeshe video hii tena',
    page_title: 'Takwimu za kozi Zako',
    page_subtitle: 'Hali ya kozi ulizounda',
    profile_add_info:
     ' Ongeza <1> {{Nakala isiyokamilika}} </1> kukamilisha wasifu wako.',
    profile_build:
     'Jenga wasifu wako <1> hapa </1>   tujulishe mambo unayopenda na ujuzi.',
    profile_title: 'Nguvu ya wasifu',
    more_details: 'Maelezo Zaidi'
  },

  errors: {
    answer: 'Tafadhali jibu',
    answer_correct: 'Chagua jibu sahihi',
    code: 'Tafadhali ingiza nambari yako',
    criterion: 'Tafadhali ingiza kigezo',
    duration: 'Muda unahitajika',
    element: 'Tafadhali ingiza kipengee',
    email: 'Tafadhali ingiza barua pepe yako',
    email_invalid: 'Ingizo sio barua pepe halali',
    feedback_correct: 'Tafadhali ingiza maoni sahihi',
    feedback_incorrect: 'Tafadhali ingiza maoni sio sahihi',
    host: 'Tafadhali ingiza mwenyeji wa hafla ya tukio',
    host_assessment: 'Tafadhali ingiza tathmini ya mwenyeji',
    image: 'Tafadhali pakia picha',
    location: 'Tafadhali ingiza eneo lako',
    live_location: 'Tafadhali chagua eneo la utangazaji',
    limit: 'Tafadhali ingiza dakika za kusambaza moja kwa moja',
    min_3char: 'isipungue herufi tatu',
    number: 'tafadhali ingiza nambari chanya.',
    host_email_require: `Barua pepe za mwenyeji zinahitajika.`,
    attendee_email_require: `Barua pepe za waliohudhuria zinahitajika.`,
    name: 'Tafadhali ingiza jina lako',
    not_found_course: 'Kozi haipatikani',
    not_found_event: 'Tukio halikupatikani',
    not_found_assessment: 'Tathmini haipatikani',
    password: 'Tafadhali ingiza nenosiri lako',
    password_digit: 'Angalau tarakimu moja',
    password_short: 'Nenosiri ni fupi sana, ispungue herufi 10',
    password_special: 'Angalau herufi moja maalum',
    password_uppercase: 'Angalau herufi moja kubwa',
    password_lowercase: 'Angalau herufi moja ndogo',
    phone: 'Tafadhali ingiza nambari yako ya simu yako',
    phone_invalid: 'Nambari batili ya simu',
    position: 'Tafadhali ingiza msimamo wako',
    question: 'Tafadhali ingiza swali',
    start_date: 'Tarehe ya kuanza na Wakati unahitajika',
    tag: 'Tafadhali chagua tepe',
    topics: 'Tafadhali chagua mada angalau moja.',
    live_topics: 'Tafadhali ongeza mada',
    title: 'Tafadhali ingiza kichwa',
    title_assessment: 'Tafadhali ingiza kichwa cha tathmini',
    title_course: 'Tafadhali ingiza kichwa cha kozi',
    title_empty: 'Kichwa hakiwezi kuwa tupu',
    title_event: 'Tafadhali ingiza kichwa cha tukio',
    title_lesson: 'Tafadhali ingiza kichwa cha somo',
    title_quiz: 'Tafadhali ingiza jina la jaribio',
    username: 'Tafadhali ingiza jina lako la mtumiaji',
    upload_error: 'Kosa - Faili haifai!',
    upload_more_than_10: 'Unaweza kupakia faili kumi tu mara moja.',
    topics_max: 'Tafadhali ongeza mada tatu tu pekee.',
    upload_excel: 'Tafadhali hakikisha umepakia faili sahihi.',
    title_excel: 'Kosa la kupakia templeti:',
    file_size_exceed: 'Saizi ya faili inazidi',
    subtitle_excel:
     'Tafadhali hakikisha kutumia templeti iliyotolewa na nguzo zimejazwa kwa usahihi.',
    select_broadcast_option: 'Tafadhali chagua chaguo kutangaza tukio hili',
    multi_hosts_number_error:
     'Nambari ya mwenyeji hayawezi kuzidi kuliko ilivyoainishwa kwa hafla hiyo.',
    conference_people_number_error: `Nambari ya mtangazaji hayawezi kuzidi kuliko ilivyoainishwa kwa hafla hiyo.`,
    select_max_host: 'Chagua mtangazaji angalau moja kwa hafla hiyo.',
    select_max_conference: 'Chagua angalau mhudumu mmoja wa tukio hilo.',
    stream_stop_error: 'Inajaribu kuunganisha tena...',
    no_stream_error: 'Inasubiri mwenyeji kuanza tukio',
    unsecure_context:
     'Kosa mbaya: Kivinjari hakiwezi kupata kamera na mic kwa sababu ya muktadha wa usalama. Tafadhali sasisha SSL na ufikie kupitia https',
    ws_not_supported: 'Kosa mbaya: WebSocket haijaungwa mkono katika kivinjari hiki',

    // added_first
    no_org: 'Chagua angalau shirika 1 kuendelea.',
    no_org_group: 'Chagua angalau kikundi cha shirika 1 kuendelea.',
    waiting_to_join: 'Inasubiri mtu ajiunge!'
  },

  events: {
    title: 'Ongeza Maelezo ya Tukio Moja kwa Moja',
    change_host: 'Badilisha mtangazaji',
    finished: 'Tukio limekamilika',
    countdown: 'Tukio la moja kwa moja litatangaza kwa',
    subtitle:
     'Lipe jina tukio lako la Moja kwa moja na uwaambie watazamaji wako kile wanatarajia kujifunza kutoka kwako.',
    poll_disabled: 'Kura haipatikani katika hafla hii',
    disclaimer: `Niagiza kwamba hafla yangu iliyorekodiwa haitafanya:
    - kukiuka haki za mtu yeyote wa tatu
  - Inayo uharamia wowote   pamoja na uchafu
  - Inashambulia mtu yeyote kwa watu wengine
  - Inayo uigaji wowote wa washiriki wengine   takwimu za umma au watu mashuhuri
  - Inayo habari yoyote ya kurekodi au ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na haiko katika ukiukaji wa sheria yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
  - Inayo rufaa ya kibiashara au aina yoyote ya "barua taka"`,
    prompt_message:
     'Kuondoka kwenye ukurasa huu utamaliza hafla yako. Una uhakika wa kuacha ukurasa huu?',
    duration_exceed_message:
     ' Wakati wako wa utangazaji unazidi  App itaacha kutangaza.',
    before_schedule_message:
     'Uko karibu kuanza utangazaji kabla ya wakati wa tukio uliopangwa. Tafadhali kumbuka kuwa kuzuia utangazaji kumaliza tukio.',
    browser_unsupportive_message:
     'Kivinjari chako hakiingiliani na kushiriki skrini. Unaweza kuona vivinjari vilivyoungwa mkono kwenye kiunga hiki',
    cancel_switch_host_message:
      'Mwenyeji halipatikani. Hafla hiyo itaendelea kutoka kwako.',
    coaching_prompt_message:
     'Hauwezi kuacha ukurasa huu hadi tukio litakapokamilika.',
    event_modal_warn: 'Je! Unataka kuacha tukio hili?',
    confirm_message: 'Tukio lako litaisha ikiwa bonyeza Ndiyo.',
    screen_share_denied: 'Umekataa kushiriki skrini yako',
    media_not_found:
     'Kamera au Mic hazipatikani au haziruhusiwi kwenye kifaa chako.',
    media_not_access:
     'Kamera au Mic inatumiwa na michakato mingine ambayo hairuhusu kusoma vifaa',
    constraint_error:
     'Hakuna kifaa kilichopatikana kinacholingana na vizuizi vya video na sauti. Unaweza kubadilisha vizuizi vya video na sauti',
    media_access_denied: 'Hauruhusiwi kupata kamera na mic.'
  },

  filters: {
    days7: 'Siku 7 zilizopita',
    days15: 'Siku 15 zilizopita',
    days30: 'Siku 30 zilizopita',
    days365: 'Siku 365 za zilizopita',
    date: 'Tarehe iliyoundwa',
    relevance: 'Umuhimu',
    popularity: ' Umaarufu',
    name: 'Jina',
    group: 'Kikundi',
    Newest_to_Oldest: 'Mpya zaidi kwa zee zaidi',
    Oldest_to_Newest: 'zee zaidi kwa Mpya zaidi',
    A_Z: 'A hadi Z',
    Z_A: 'Z hadi A'
  },

  helpers: {
    password:
     'Ili kuhakikisha usalama wa akaunti yako tunahitaji angalau alama ndogo moja   nambari yako katika nenosiri lako. Unahitaji pia kuwa na urefu wa chini wa herufi 10.',
    phone: 'Tafadhali weka nambari yako ya nchi ya simu kwa mfano: +65',
    username:
     'Jina lako la mtumiaji linatibiwa kama habari ya umma na hushirikiwa na watumiaji wengine kama inahitajika. Kama hivyo   tunapendekeza usitumie habari za kibinafsi katika jina lako la mtumiaji',
    public_description_normal:
     'Yako <0><0/> </0> imehifadhiwa na inachukuliwa kuwa ya faragha kwa msingi. Hii inamaanisha kuwa wewe tu unaweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa. Chaguo Maalum la Watumiaji litakuwezesha kushiriki kozi yako na watumiaji maalum kwa kutumia anwani ya barua pepe inayohusiana na akaunti yao ya Shiriki.',
    public_description_admin:
     'Hii <0><0/> </0> imehifadhiwa na inachukuliwa kuwa ya faragha kwa msingi. Hii inamaanisha kuwa wewe tu (na muundaji wa yaliyomo) ndiye anayeweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa - pamoja na wale walio nje ya shirika lako. Kuichapisha kwa shirika kunamaanisha kuwa watumiaji wote ndani ya shirika wataweza kuiona. Unaweza kuichapisha kwa vikundi 1 au zaidi   ikimaanisha watumiaji tu kwenye vikundi hivyo wataweza kuiona. Mwishowe   una chaguo la kuchapisha kwa watumiaji maalum ndani na nje ya shirika lako kwa kutumia anwani yao ya barua pepe ya akaunti ya ShareLook.'
  },

  labels: {
    add: 'Ongeza',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Aina ya Jibu',
    answers: 'Majibu',
    back_to_quiz: 'Rudi kwenye orodha ya jaribio',
    back_to_question: 'Rudi kwenye orodha ya maswali',
    chat: 'Maongezi',
    chat_available: 'Maongezi haipatikani katika hafla hii',
    chat_report: 'Ripoti ya maongezi',
    choice_single: 'Chaguo moja',
    choice_multiple: 'Chaguo nyingi',
    choice_free: '"chaguo lolote "',
    choice_sorting: '"chaguo la Kuamua"',
    choice_matrix: '"chaguo la Matrix"',
    clone_lesson_permission: 'Ruhusa ya Clone',
    code: 'Code',
    correct: 'Sahihi',
    created: 'Tarehe iliyoundwa',
    clone_modal: 'Clone kozi',
    cloning_course: 'Inaclone Kozi...',
    cloning: 'Cloning...',
    cloning_course_desc: 'Mchakato huu utachukua muda. Tafadhali kuwa na subira',
    cloning_success: 'Kozi" <0 /> "imeumbwa kwa usawa!',
    description: 'Maelezo',
    disclaimer: 'Kanusho',
    drop_file: 'Weka faili hapa...',
    duration: ' Muda',
    edit: 'Hariri',
    email: 'barua pepe',
    event: 'Tukio',
    event_all: 'Matukio yake yote',
    event_date: 'Wakati na tarehe ya kawaida ya Tukio la Moja kwa moja',
    event_this: 'Hafla hii',
    expire: 'Kuisha kwa',
    expiry_date: 'Tarehe ya mwisho wa matumizi',
    forgot: 'Umesahau nenosiri?',
    group: 'Kikundi',
    groups_list: 'Orodha ya Vikundi',
    host: 'mwenyeji',
    id_annotation: 'Annotation id',
    id_number: 'nambari ya kitambulisho',
    id_quiz: 'Kitambulisho cha jaribio',
    incorrect: 'Sio sahihi',
    interests: 'masilahi',
    invited: 'Umealikwa',
    live_chat: 'Majadiliano ya moja kwa moja',
    live_stream_limit: 'Dakika za Kutiririka Moja kwa Moja',
    contact_text: 'Ili kubadilisha kikomo chako cha utiririshaji wa moja kwa moja tafadhali wasiliana',
    contact_admin:
     '<0> Ikiwa unataka kubadilisha kikomo chako cha kutiririsha matangazo moja kwa moja tafadhali wasiliana </0> <1> admin@shareview.com </1>',
    limit_stream_text:
     'Dakika zilizosambaa kwa Moja kwa Moja: <0> {{kikomo}} </0> dakika <1 /> <2 /> <3> Ili kubadilisha kikomo chako cha kusisimua moja kwa moja tafadhali wasiliana na </3> <4> admin @ shareLook.com </4>',
    location: ' Mahali',
    lessons: 'Masomo',
    location_broadcast: 'Mahali pa Seva ya Wasimamizi',
    location_broadcast_subtitle:
     'Ongeza eneo ambalo karibu zaidi na eneo la mwenyeji wa matangazo ili kupunguza kuchelewesha kwa sauti',
    media_manager: 'Meneja wa media',
    minutes: 'Dakika',
    name: 'Jina',
    online_quiz: 'Jaribio Mtandaoni',
    organiser: 'Mwandishi',
    organization: 'Shirika',
    overall_emotion: 'Uzoefu wa Jumla:',
    organizations_list: 'Orodha ya mashirika',
    password: 'Nenosiri',
    participants: 'Washiriki',
    picture: 'Picha (16:9)',
    phone: 'Simu',
    photo: 'Picha',
    poll: 'Kura',
    position: 'Nafasi',
    processing: 'Inachakata',
    privacy_settings: 'Mipangilio ya faragha',
    question: 'Swali',
    quiz_create: 'Unda Jaribio Mpya',
    quiz_name: 'Jina la Jaribio',
    quiz_update: 'Sasisha jaribio',
    select_organization: 'Chagua shirika',
    settings: 'Mipangilio',
    show: 'Onyesha',
    show_graph: 'Onyesha matokeo kwa grafu',
    signin: 'Ingia',
    signup: 'Jisajili',
    sort_by: 'Panga kwa',
    start_date: 'Tarehe ya kuanza',
    tags: 'Tepe',
    terms: 'Ninakubali <1> sheria na masharti haya </1>.',
    title: 'Kichwa',
    topics: 'Mada',
    topic: 'Mada',
    total_comments: 'Jumla ya Maoni',
    username: 'Jina la mtumiaji',
    users_list: 'Orodha ya Watumiaji',
    users_emails: 'Ingiza barua pepe za watumiaji',
    description_specifiction_email:
     'Tafadhali ingiza anwani 1 ya barua pepe kwa kila mstari ili kushiriki hii na watumiaji maalum.',
    message_specific_email: ' Tafadhali ingiza barua pepe ya mtumiaji maalum.',
    viewers: 'Watazamaji',
    edit_course: 'Hariri',
    edit_assessment: 'Hariri',
    edit_event: 'Hariri',
    delete_course: 'Futa',
    delete_event: 'Futa',
    delete_assessment: 'Futa',
    view_course: 'Tazama',
    view_event: 'Tazama',
    view_assessment: 'Tazama',
    date_event: 'Tarehe ya tukio moja kwa moja',
    date_assessment: 'Tarehe ya tathmini ya moja kwa moja',
    clone_of: 'Clone',
    clone_course:
     'Unda clone ya kozi hii ambayo unaweza kurekebisha bila ya asili   inajumuisha masomo yote na kurasa.',
    make: 'Fanya',
    available_to: 'Inapatikana kwa mtumiaji yeyote wa ShareLook',
    uploaded_by: 'Imepakiwa na: ',
    course: 'Kozi',
    assessment: 'Tathmini',
    user_not_exist: 'Mtumiaji hayupo   ungependa kutuma mwaliko?',
    check_user: 'Ilani',
    user_not_exist_in_org:
     'Mtumiaji hayupo katika shirika hili   ungependa kutuma mwaliko?',
    title_modal_stream: 'Badili kikomo cha shirika cha utiririshaji wa moja kwa moja',
    des_warning_stream: 'Umekaribia kubadili',
    monthly_stream: 'Kila kikomo cha mwezi cha utiririshaji wa moja kwa moja:',
    min_per_month: 'Dakika / mwezi',
    broadcast_label: 'Ninataka kufanya:',
    hosts_emails: 'Ingiza barua pepe maalum za mwenyeji ',
    attendee_emails: 'Ingiza barua pepe maalum za waliohudhuria',
    description_host_specifiction_email:
  'Tafadhali ingiza anwani 1 ya barua pepe kwa kila mstari.',
    presenter_label: 'Mtangazaji',
    presenter_label_conference: 'idadi ya watu',
    event_privacy: 'Mbinu ya Mkutano',
    // added_second
    alert: 'Tahadhari!',
    warning: 'Onyo!',
    ok: 'Sawa',
    cancel: 'Ghairi',
    done: 'Imekamilika',
    insert: 'Ingiza',
    private: 'Binafsi',
    public: 'Umma',
    no_connection: 'Uunganisho wa Mtandaoni Umepotea',
    switch: 'Badili',
    share_screen: 'Shiriki Skirini',
    stop_share_screen: 'Acha Kushiriki Skirini',
    share_screen_with_camera: 'Shiriki Skrini na kamera',
    stop_share_screen_with_camera: 'Acha Kushiriki Skrini na kamera',
    camera_on: 'Kamera Imewashwa',
    camera_off: 'Kamera Imezimwa',
    mic_on: 'Cheza sauti',
    mic_off: 'Zima sauti',
    fullscreen: 'Skrini kamili',
    live_now: 'Moja kwa moja sasa hivi',
    schedule_on: 'Ratiba ya',
    organisations: 'Mashirika',
    org_groups: 'Vikundi vya Shirika',
    specific_user: 'Mtumiaji Maalum',
    gif: 'GIF',
    unavailable: 'haipatikani',
    yes: 'Ndio',
    no: 'Hapana',
    event_duration_message: 'Upeo wa dakika 300 (5hrs)',
    send_email: 'Tuma Arifa ya barua pepe',
    admin_only: 'Msimamizi tu',
    join: 'Jiunge',
    leave: 'Ondoka'
  },

  broadcastOptions: {
    stream_from_phone: 'Matangazo ya moja kwa moja na simu yangu',
    other_webrtc: 'Webinar kutoka kwa Kompyuta',
    multihost: 'Multicast webinar kutoka kwa kompyuta',
    peer2peer: 'Kikao cha kufundisha',
    conference: 'Mkutano wa Moja kwa Moja'
  },

  lessoncreate: {
    title: 'Ongeza maelezo ya somo',
    subtitle:
  ' Lipe jina somo lako na uwaambie watazamaji wako kile wanatarajia kujifunza kutoka kwake.',
    input_label_title: 'Kichwa cha Somo',
    input_label_topics: 'Mada za masomo',
    input_label_description: 'Maelezo ya somo',
    delete_warning: ' Je! Una uhakika unataka kufuta ukurasa huu?'
  },

  lessonoverview: {
    title: 'Ongeza Somo',
    subtitle: 'Ongeza somo lililopo au unda mpya',
    new_lesson: 'unda somo mpya',
    new_lesson_sub: 'Tengeneza somo jipya kutoka mwanzo!',
    existing_lesson: 'Chagua somo lililopo',
    existing_lesson_sub:
  'Unganisha na somo lililopo   mabadiliko yaliyofanywa kwa somo hili pia yataathiri somo hili katika kozi zingine.',
    clone_lesson: 'fanya tena somo lililopo',
    clone_lesson_sub:
  'Tengeneza nakala ya kipekee ya somo katika kozi hii   mabadiliko yaliyofanywa kwa somo hili hayataathiri somo la awali.',
    clone_lesson_modal_sub:
  'Tafadhali bonyeza kitufe cha chini cha somo ambalo ungependa kuongeza kwenye kozi yako.'
  },

  management: {
    groups_title: 'Dhibiti Vikundi',
    delete_warning: 'Una uhakika?',
    organizations_title: 'Mashirika yangu',
    organizations_subtitle: '  Ongeza mashirika kwenye orodha yako',
    users_title: 'Dhibiti Watumiaji',
    users_position: 'Meneja Mkuu wa Akaunti',
    user_not_found: 'Mtumiaji Hajapatikana',
    select_org: 'Tafadhali pata na uchague shirika la kusimamia watumiaji'
  },

  audio: {
    modal_title: 'Ingiza Sauti',
    list_view: 'Tazama Orodha',
    create_audio_modal_title: 'Unda Sauti',
    edit_audio_modal_title: 'Hariri Sauti',
    public_audio_not_found: 'Sauti haipatikani.',
    private_audio_not_found: 'Bado haujapakia sauti yoyote',
    org_audio_not_found: 'Sauti haipatikani.',
    are_you_sure_to_delete: 'Je! Una uhakika unataka kufuta?',
    type_something: 'Chapa kitu',
    select_voice: 'Chagua',
    file_name: 'Jina la faili',
    description: 'Maelezo',
    topic: 'Mada',
    key_words_tag: 'Lebo ya Maneno muhimu',
    mp3_audio: 'MP3 Audio',
    created: 'Imeundwa',
    duration: 'Muda',
    close: 'funga'
  },

  image: {
    modal_title: 'Ingiza Picha',
    image: 'Picha',
    pixel: 'Pixel',
    dimension: 'Vipimo',
    public_image_not_found: 'Picha haikupatikana.',
    private_image_not_found: 'Bado haujapakia picha yoyote',
    org_image_not_found: 'Picha haikupatikana.'
  },

  annotation: {
    modal_title: 'Ufafanuzi'
  },

  text: {
    modal_title: 'Hariri ya maandishi'
  },

  video: {
    modal_title: 'Ingiza Video',
    image: 'Video',
    mp4_video: 'Video ya MP4',
    public_video_not_found: 'Video haipatikani.',
    private_video_not_found: 'Bado haujapakia video yoyote',
    org_video_not_found: 'Video haipatikani.'
  },

  media: {
    title: 'Maktaba ya Media',
    subtitle: 'Maktaba ya faili zako',
    modal_title: 'pakia media',
    delete_warning: 'Thibitisha kufuta',
    delete_message:
  'Media iliyofutwa bado itaonekana kwenye kurasa ambazo zilitumiwa',
    dropzone_text: 'au Buruta na Ushushe',
    delete_success: 'Media imeondolewa kwa mafanikio',
    upload_file: 'Pakia faili',
    drag_drop: 'au Buruta na Ushushe',
    import_file: 'Toa faili (faili) kutoka kwa kompyuta yako',
    no_media: 'Bado haujapakia media yoyote',
    media_type: 'Aina ya media',
    video: 'Video',
    image: 'Picha',
    audio: 'Sauti',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Media haikupatikana.',
    of: 'ya',
    disclaimer: `Ninasisitiza kwamba media yangu haina:
     - kukiuka haki za mtu yeyote wa tatu
     - Inayo uharamia wowote   pamoja na uchafu
     - Inashambulia mtu yeyote kwa watu wengine
     - Inayo uigaji wowote wa washiriki wengine   takwimu za umma au watu mashuhuri
     - ina habari yoyote ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na sio kwa kukiuka kanuni yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
     - Inayo rufaa ya kibiashara au aina yoyote ya "barua taka”`,

    // added_first
    my_media: 'Media Yangu',
    public_library: 'Maktaba ya Umma',
    organization_library: 'Maktaba ya shirika',
    upload_from_computer: 'Pakia kutoka kwa Kompyuta',
    pexel_images: 'Picha za Pexel',
    create: 'Unda',
    all: 'Wote',
    male: 'Mwanaume',
    female: 'Mwanamke',
    processing_audio: 'Inashughulikia Sauti',
    create_annotation: 'Unda Ujumbe',
    popup_over_lesson_text:
  'Maelezo haya yatatoka kwenye ukurasa wa somo baada ya kubonyeza',
    edit_detail: 'Hariri Maelezo',
    delete: 'Futa',
    go_create_audio: 'Nenda Unda Sauti',
    show_more_details: 'onyesha maelezo zaidi',
    show_less_details: 'onyesha maelezo kidogo',
    drop_files: 'Tupa faili na mahali pa kupakia',
    or: 'Au',
    import_files: 'Ingiza faili kutoka kwa kompyuta'
  },

  navigation: {
    account: 'Akaunti',
    assessments: 'Tathmini',
    dashboard: 'Dashibodi',
    groups: 'Usimamizi wa Kikundi',
    logout: 'Ondoka',
    organisations: 'Mashirika',
    organizations_users: 'Mashirika na Watumiaji',
    reports: 'Ripoti',
    schedule: 'Ratiba',
    training: 'Mafunzo',
    users: 'Watumiaji',

    // added_first
    nowLive: 'moja kwa moja',

    workshop: 'Warsha yangu'
  },

  onboarding: {
    step1_title: 'Hatua ya 1: Tuambie Kidogo Kuhusu Wewe mwenyewe',
    step1_subtitle:
  'Jina lako nani? Unatoka wapi? Jina lako la kazi ni?',
    step2_title: 'Hatua ya 2: Chagua Ustadi Wengine Uliweza Kuboresha Katika',
    step2_subtitle:
  'Ijayo   tuambie nini ungependa kuelewa vizuri zaidi. Labda kitu ambacho bado unachohitaji kuchukua? Uwanja mpya wa kusoma? Je! Mpendwa wako anafanya nini?'
  },

  pagebuilder: {
    title: 'Unda Somo',
    subtitle:
  'Wakati wa kuunda yaliyomo kwa watazamaji wako kujifunza kutoka kwako   unaweza kupiga picha   video na infographics',
    select_layout: 'Chagua Mpangilio wa Ukurasa',
    template1: 'Blank',
    template2: 'Kichwa & Manukuu',
    template3: 'Kichwa & Maandishi',
    template4: 'Kichwa   Media na Nakala',
    template5: 'Kichwa & Media',
    template6: 'Kichwa & Jaribio'
  },

  pageconstructor: {
    title: 'Unda na Somo la Clone',
    subtitle:
  'Wakati wa kuunda yaliyomo kwa watazamaji wako kujifunza kutoka kwako   unaweza kuongeza picha   video na infographics'
  },

  passwordreset: {
    success_coded:
    'Tumetuma nambari ya uthibitisho kwa barua pepe kwa anwani uliyotoa   tafadhali nakili nambari hiyo kwenye uwanja hapa chini kuweka nenosiri mpya.',
    success_changed:
  'Umefanikiwa kuweka nywila mpya. Unaweza kuingia sasa.'
  },

  placeholders: {
    search: 'Tafuta',
    answer: 'Jibu',
    chat: 'Sema kitu…',
    code: 'Code',
    criterion: 'Furqani',
    date_event: 'Chagua tarehe na wakati',
    date_start: 'Tarehe ya kuanza',
    date_expire: 'Tarehe ya mwisho wa matumizi',
    description: 'Maelezo',
    elements: 'Panga vitu',
    email: 'Barua pepe',
    feedback_correct: 'Maoni ni Sahihi',
    feedback_incorrect: 'Maoni Sio sahihi',
    host: 'Mwenyeji',
    keywords: 'Tafuta Maneno muhimu',
    lesson_description: 'Maelezo ya somo',
    location: 'Mahali',
    minutes: 'Dakika',
    name: 'Jina',
    organiser: 'Mwandishi',
    organization: 'Shirika',
    password: 'Nenosiri',
    phone: 'Simu',
    photo: 'Picha',
    picture: 'Picha',
    point: 'Kidokezo',
    position: 'Nafasi',
    question: 'Swali',
    quiz: 'Jina la jaribio',
    search_course: 'Tafuta na Kozi',
    search_media: 'Tafuta media',
    search_name: 'Tafuta kwa Jina',
    search_title: 'Tafuta na Kichwa',
    search_training: 'Tafuta Mafunzo',
    settings: 'Mipangilio',
    tags: 'Tepe',
    title: 'Kichwa',
    topics: 'Mada',
    username: 'Jina la mtumiaji',
    keyword: 'Maneno muhimu',
    max_500_characters: 'isipite herufi 500',
    no_description: 'Faili hii haina maelezo',
    no_keyword: 'Faili hii haina maneno muhimu yoyote',
    no_topics: 'Faili hii haina seti ya mada',
    feedback: 'Ujumbe',
    contact: 'Jinsi tunaweza kusaidia?'
  },

  publishsettings: {
    title: 'Mipangilio ya Kuchapisha',
    event_subtitle:
  'Ongeza mipangilio kwenye hafla yako   ambaye anaweza kutazama na kuingiliana na tukio lako',
    assessment_subtitile:
  'Taja tathmini yako na uwaambie watazamaji wako kile wanatarajia kujifunza kutoka kwake',
    course_subtitle:
  'Ongeza mipangilio kwenye kozi yako   ni nani anayeweza kutazama na kuingiliana na kozi yako',
    disclaimer:
  'Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Null am venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis',
    dates_validation_error: 'Tarehe zote mbili zinapaswa kujazwa.',
    emails_validation_error: 'Orodha ya barua pepe sio sahihi.',
    specific_email_validation_error: 'Barua pepe moja tu ndiyo inaruhusiwa.',
    i_agree_to_these: 'Ninakubali hizi',
    terms_and_conditions: 'sheria na Masharti.',
    PublicDescription: 'Watumiaji wa bure huria: (chaguzi za kibinafsi na za umma) [Kozi yako | Tukio | Tathmini] imehifadhiwa na inachukuliwa kuwa ya faragha. Hii inamaanisha kuwa wewe tu unaweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua kuifanya iwe ya umma chini. Hii inamaanisha kuwa kozi hiyo itapatikana kwa watumiaji wote kwenye jukwaa.',
    OrganisationsDescription:
    'Watumiaji wa  Shirika: (Badala ya "" Maliza "" tumia "" Chapisha "" na uwalete kwenye ukurasa wa kuchapisha sawa na watumiaji wengine lakini bila chaguzi zozote za kuchapisha.) [Kozi ya Tukio | Tathmini yako] imehifadhiwa na ni ya kibinafsi. Hii inamaanisha kuwa wewe na watawala katika shirika lako ndio mnaweza kuiona. Kama mtumiaji   hauwezi kuchapisha yaliyomo ndani ya shirika lako mwenyewe kwani hii inahitaji haki za msimamizi. Tafadhali wasiliana na mmoja wa Wasimamizi wako na uwaombe wachapishe yaliyomo kwako hadharani   kwa shirika lote   kwa vikundi maalum ndani ya shirika lako au kwa watumiaji fulani.',
    OrganisationGroupsDescription:
  'Msimamizi wa shirika: (Kwa yaliyomo ndani ya shirika: Binafsi   umma   shirika   vikundi   watumiaji fulani): Hii [Kozi ya Tukio | Tathmini] imehifadhiwa na inachukuliwa kuwa ya faragha. Hii inamaanisha kuwa wewe tu (na muundaji wa yaliyomo) ndiye anayeweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa - pamoja na wale walio nje ya shirika lako. Kuichapisha kwa shirika kunamaanisha kuwa watumiaji wote ndani ya shirika wataweza kuiona. Unaweza kuichapisha kwa vikundi 1 au zaidi   ikimaanisha watumiaji tu kwenye vikundi hivyo wataweza kuiona. Mwishowe   una chaguo la kuchapisha kwa watumiaji maalum ndani na nje ya shirika lako kwa kutumia anwani yao ya barua pepe ya akaunti ya ShareLook.',
    SpecificUsersDescription:
  'Watumiaji wa Uhuru waliolipwa: (ya kibinafsi   ya umma na watumiaji maalum) [Kozi ya [Tukio lako] Tathmini] Imehifadhiwa na inachukuliwa kuwa ya faragha. Hii inamaanisha kuwa wewe tu unaweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa. Chaguo Maalum la Watumiaji litakuwezesha kushiriki kozi yako na watumiaji maalum kwa kutumia anwani ya barua pepe inayohusiana na akaunti yao ya ShareLook.'
  },

  quiz: {
    quiz_empty: 'Bado haujafanya jaribio',
    questions_empty: 'Bado haujaunda swali'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'Korea Kusini',
    asia_pacific_singapore: 'Singapore',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Ubelgiji',
    eu_germany: 'Ujerumani',
    eu_ireland: 'Ireland',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'South Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },
  reports: {
    title: 'Ripoti',

    // added_first
    workshop_report: 'Ripoti ya Warsha',
    user_report: 'Ripoti ya Mtumiaji',
    organization_workshop: 'Warsha ya shirika',
    course: 'Kozi',
    live_event: 'Tukio la moja kwa moja',
    workShop_graph: 'Grafu ya Warsha',
    organization_account: 'Akaunti ya shirika',
    all: 'Wote',
    name: 'Jina',
    id_number: 'Nambari ya kitambulisho',
    email: 'Barua pepe',
    search_user_report: 'Tafuta Ripoti ya Mtumiaji',
    participant: 'Mshiriki',
    participants: 'Washiriki',
    host: 'Mwenyeji',
    username: 'Jina la mtumiaji',
    event: 'Tukio',
    quiz: 'Jaribio',
    assessment: 'Tathmini',
    time: 'Wakati',
    no_recent_activity: 'Hakuna shughuli ya Hivi majuzi',
    workshops: 'Warsha',
    courses: 'Kozi',
    live_events: 'Matukio ya moja kwa moja',
    live_assessments: 'Tathmini za Moja kwa moja',
    quizzes: 'Majaribio',
    overview: 'Maelezo ya jumla',
    by: 'Na',
    views: 'Maoni',
    status: 'Hali',
    poll: 'Kura',
    comment: 'Maoni',
    comments: 'Maoni',
    no_comments: 'Hakuna maoni',
    no_polls: 'Hakuna Kura',
    live_date: 'Tarehe ya moja kwa moja',
    score: 'Alama',
    question: 'Swali',
    submit: 'Tuma',
    recent_activity: 'Shughuli za hivi karibuni',
    ago: 'Iliyopita',
    no_data_found: 'Hakuna data iliyopatikana',
    start_end_live: 'Anza / Maliza tukio la moja kwa moja',
    join_leave_date: 'Jiunge / Ondoka',
    watched_time: 'Wakati uliotengwa',
    complete: 'Kamilisha',
    in_complete: 'Katika Kukamilisha',
    today: 'Leo',
    seven_days: 'Siku 7',
    last_month: 'Mwezi uliopita',
    one_year: 'Mwaka 1',
    all_time: 'Muda wote',
    report: 'Ripoti',
    from_date: 'Kuanzia Tarehe',
    to_date: 'Mpaka leo',
    all_workshop: 'Warsha Yote',
    all_participants: 'Washiriki wote',
    live_assessment: 'Tathmini ya Moja kwa moja',
    users: 'Watumiaji',
    download: 'Pakua',
    recent: 'Hivi karibuni',
    WorkShop: 'Warsha',
    Activity: 'Shughuli',
    created_date: 'Tarehe iliyoundwa',
    lessons: 'Masomo',
    lesson: 'Somo',
    completed: 'Imekamilika',
    report_download: 'Pakua ripoti',
    this_month: 'Mwezi huu',
    search_course: 'Kozi ya Kutafuta',
    participants_graph: 'Wagiriki washiriki',
    viewed: 'Imetazamwa',
    enrolled: 'Imeandikishwa',
    description: 'Maelezo',
    topic: 'Mada',
    analytic: 'Mchanganuzi',
    quiz_list: 'Orodha ya jaribio',
    select_one: 'Chagua moja',
    group_status: 'Hali ya kikundi',
    duration_min: 'Muda (dakika)',
    submit_poll: 'Tuma kura',
    download_events: 'Pakua Matukio',
    search_event: 'Tukio la utaftaji',
    duration: 'Muda',
    total_participants: 'washiriki wote',
    message: 'Ujumbe',
    avg_message: 'Ujumbe wa wastani',
    per_message: 'Asilimia ya ujumbe/tukio'
  },

  signup: {
    success_step1:
    'Tumetuma nambari ya ukaguzi kwa barua pepe uliyotoa   tafadhali nakili nambari katika uwanja ulio chini ili uthibitishe usajili wako.',
    success_step2: 'Tumetuma nambari ya ukaguzi kwa barua pepe uliyotoa   tafadhali nakili nambari katika uwanja ulio chini ili uthibitishe usajili wako.',
    privacy: `Ninakubali Sheria na Masharti ya Sharelook </1> na <2> sera ya faragha`
  },

  stream: {
    emotion_impressive: 'Kuvutia',
    emotion_unimpressive: 'Haifurahishi',
    message_not_started: 'Yajao Hivi karibuni',
    message_running: 'Moja kwa moja',
    message_processing:
  'Hivi sasa tunashughulikia rekodi ya moja kwa moja ya kucheza tena. Tafadhali angalia tena baadaye kutazama video na kuendelea kuongeza ukadiriaji na maoni'
  },

  tabs: {
    audience: 'Watazamaji',
    course: 'muhtasari wa kozi',
    details: 'Maelezo ya Tukio la Moja kwa Moja',
    description: 'Maelezo',
    host: 'mwenyeji',
    lesson: 'Maelezo ya Jumla ya Somo',
    lessons: 'Masomo',
    overview: 'Maelezo ya jumla',
    page: 'Mjenzi wa Ukurasa',
    publish: 'Chapisha',
    settings: 'Mipangilio ya kuchapisha',
    total_views: 'Jumla ya utazamaji',
    live_participates: 'Washiriki wa Moja kwa Moja',
    live_chats: 'Maongezi ya moja kwa moja',
    live_quiz: 'Kura za moja kwa moja',
    trainer_rating: 'Kiwango vya mkufunzi',
    trainer_times: 'wakati wa Mkufunzi',
    courses_quizzes: 'majaribio ya kozi',
    user_list: 'Orodha ya Watumiaji',
    discussion: 'Majadiliano',
    notes: 'Vidokezo Vyangu'
  },

  topics: {
    SALES_TRAINING: 'Mafunzo ya Uuzaji',
    NEGOTIATION_TRAINING: 'Mafunzo ya Mazungumzo',
    CROSS_CULTURAL_AWARENESS: 'Utafahamu wa Kitamaduni',
    NETWORKING_SKILLS: 'Ujuzi wa Kuungana',
    SOFTWARE_ARCHITECTURE: 'Usanifu wa Programu',
    PROJECT_MANAGEMENT: 'Usimamizi wa Mradi',
    DIGITAL_TRANSFORMATION: 'Mabadiliko ya dijiti',
    IT_CONSULTING: 'Ushauri wa IT',
    MANAGEMENT_CONSULTING: 'Ushauri wa Usimamizi',
    HR_CONSULTING: 'Ushauri wa wafanyikazi',
    INTERNET_OF_THINGS: 'Mtandao wa Vitu (IoT)',
    CYBERSECURITY: 'Utapeli wa cyber',
    PRIVACY_AND_GDRP: 'Usiri na GDPR'
  },

  training: {
    title: 'Mafunzo',
    title_assessment: 'Tathmini',
    subtitle: 'Kozi na Matukio ya Moja kwa Moja',
    enrolled_title: 'Kozi zilizosajiliwa na Matukio ya Moja kwa Moja',
    enrolled_subtitle: 'Kozi na Matukio ya Moja kwa moja ambayo umejiandikisha',
    enrolled_message:
  'Kwa sasa haujaandikishwa kwenye kozi zozote na tukio.',
    past_live_event_title: 'Matukio ya Awali ya Moja kwa Moja',
    past_live_event_subTitle: 'Malizo ya Matukio Moja yaliyomalikiza',
    past_live_event: 'Hivi sasa hakuna matukio ya zamani.',
    recomended_title: 'Kozi zilizopendekezwa na Matukio ya Moja kwa Moja',
    now_live_event_title: 'Matukio ya Moja kwa Moja iliyopo sasa',
    now_live_event_subTitle: 'Matukio ambayo ni ya moja kwa moja au yatakuja hivi karibuni',
    now_live_event: 'Hivi sasa hakuna tukio moja kwa moja.',
    webinar_event_title: 'Kituo cha Webinar',
    webinar_event_subTitle: 'Webinars zilizo malizika',
    webinar_event: 'Hivi sasa hakuna webinar.',
    p2p_event_title: 'Vikao vya Kufundisha',
    p2p_event_subTitle: 'Kumaliza cha kufundisha kilicho malizika',
    p2p_event: 'Hivi sasa hakuna kikao cha kufundisha.',

    now_live_assessment_title: 'moja kwa moja ipo',
    now_live_assessment_subTitle:
  'Tathmini ambayo ni moja kwa moja au itakuwa hivi karibuni',
    now_live_assessment_message: 'Kwa sasa hakuna tathmini ya moja kwa moja.',

    upcoming_assessment_title: 'Tathmini za Moja kwa Moja zijazo',
    upcoming_assessment_subtitle: 'Tathmini za Moja kwa Moja zijazo',
    upcoming_assessment_message:
  'Kwa sasa hakuna tathmini ya moja kwa moja inayokuja.',

    past_live_assessment_title: 'Kwa sasa hakuna tathmini ya moja kwa moja inayokuja',
    past_live_assessment_subTitle: 'Amemaliza Tathmini za Moja kwa Moja zilizomalizika',
    past_live_assessment_message:
  'Hivi sasa hakuna tathmini za moja kwa moja zilizopita.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
  'Tumefundisha kozi na matukio ya moja kwa moja kulingana na <0><0/> </0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Tafuta Mafunzo',
    search_assessment: 'Tafuta Tathmini',
    recomended_message:
  'Hivi sasa hakuna kozi na hafla zilizopendekezwa.',
    search_user: 'tafuta jina la kampuni'
  },
  warnings: {
    delete: 'Una uhakika?'
  },

  workshop: {
    title: 'Warsha yangu',
    subtitle: 'Tengeneza kozi au ushiriki hafla yako mwenyewe',
    new_course: 'Tengeneza kozi mpya',
    new_event: 'Unda hafla mpya ya moja kwa moja',
    new_assessment: 'Tengeneza tathmini mpya ya moja kwa moja',
    courses_title: 'Kozi zilizoundwa na Matukio ya Moja kwa Moja',
    courses_subtitle: 'Hariri na Chapisha kozi yako iliyoundwa na upange matukio ya moja kwa moja',
    tags_course: 'Kozi',
    tags_live: 'Tukio la Moja kwa Moja',
    tags_assessment: 'Tathmini ya Moja kwa Moja'
  },

  help_center: {
    sidebar: {
      title: 'Tunawezaje kukusaidia?',
      back_to: 'Dashibodi'
    },
    menu: {
      help_center: 'Kituo cha Msaada',
      whats_new: 'Nini mpya',
      feedback: 'Maoni',
      feedback_title: 'Tuma maoni kwa ShareLook',
      terms_and_conditions: 'Sheria na Masharti',
      privacy_policy: 'Sera ya faragha',
      contact_us: 'Wasiliana nasi'
    },
    get_started: {
      title: 'Anza na ShareLook',
      description: {
        main: 'TUMEUNGANISHA VIDEO YA MOJA KWA MOJA KUWA URAHISI WA KUTUMIA MJENZI WA KOZI',
        tagline:
      'Na mfumo wa matangazo ya moja kwa moja wa hakimiliki ya ShareLook   unaweza kuunda ushirika   kurahisisha kujifunza   na kuongeza kushiriki kushiriki maarifa.'
      }
    },
    whats_new: {
      title: 'Anza na ShareLook',
      description: {
        main: 'Je! Ulijua kwamba kuunda ujifunzaji wa hadithi za hadithi kunaweza kuunda katika muda mfupi na sio ghali sana? Unapaswa kuchanganya mjenzi wa kozi ya ShareLook na talanta husika. Unaweza kutuuliza "JINSI',
        tagline: ''
      }
    },
    create_workshop: 'Jinsi ya kuunda Warsha',
    create_course: 'Jinsi ya kuunda Kozi',
    create_user: 'Jinsi ya kuunda Mtumiaji',
    create_group: 'Jinsi ya kuunda Kikundi',
    create_webinar: 'Jinsi ya kuunda Webinar',
    create_live_event: 'Jinsi ya kuunda Tukio la Moja kwa Moja',
    create_live_assessment: 'Jinsi ya kuunda Tathmini ya Moja kwa Moja',
    create_live_on_mobile: 'Unda Moja kwa moja kwenye Simu ya Mkononi',
    personalize_profile: 'Kubinafsisha wasifu',
    manage_group: 'Dhibiti kikundi',
    report: 'Ripoti',
    add_annotations: 'Jinsi ya Kuongeza Vidonge',
    add_audio: 'Jinsi ya Kuongeza Sauti',
    add_header_and_footer: 'Kuongeza kichwa na nyayo',
    add_image: 'Jinsi ya Kuongeza Picha',
    add_quiz_content: 'Jinsi ya Kuongeza Yaliyomo kwenye majaribio',
    add_text_content: 'Jinsi ya Kuongeza maandishi',
    add_user: 'Jinsi ya Kuongeza Mtumiaji',
    add_video: 'Jinsi ya Kuongeza Video',
    clone_course: 'Jinsi ya kuclone Kozi',
    find_live_broadcast: 'Jinsi ya kupata Matangazo ya moja kwa moja',
    contact_us: {
      title: 'Wasiliana nasi',
      subject_placeholder: 'Ingiza somo*',
      content_placeholder: 'Ingiza ujumbe*',
      subject_required: '*Mada inahitajika',
      content_required: '*Ujumbe unahitajika',
      submit: 'Tuma',
      cancel: 'Ghairi',
      sent: 'Imetumwa'
    },
    feedback: {
      title: 'Tuma maoni kwa ShareLook',
      attach_title: 'Ambatisha faili',
      choose: 'Chagua faili',
      detail: 'Faili itashirikiwa na timu ya msaada',
      content_placeholder: 'Ingiza ujumbe*',
      content_required: '*Ujumbe unahitajika',
      submit: 'Tuma',
      cancel: 'Ghairi',
      sent: 'Imetumwa'
    }
  },
  discussion: {
    join_discussion: 'Jiunge na majadiliano'
  },
  notes: {
    title: 'Vidokezo Vyangu',
    add_note: 'Ongeza kidokezo kipya'
  },
  // added_third
  groups: {
    search_group: 'Tafuta kikundi cha shirika'
  }
}
